export default __webpack_public_path__ + "static/media/330_business03-en-mobile.fa4269f4.png";